import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaValorParcelaCurso = (): TabelaColuna => ({
  Chave: 'ValorParcelaCurso',
  ComOrdenacao: true,
  RenderizarCabecalho: () => (
    <div style={{ width: 250 }}>Valor Parcela Curso</div>
  )
})
